<template>
  <div class="skeleton">
    <content-loader height="788" widht="1440" preserveAspectRatio="none" :speed="2" primaryColor="#f3f3f3" secondaryColor="#dedede">
      <rect y="0" x="0" rx="0" ry="0" width="100%" height="100%" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: 'Skeleton',
  components: {
    ContentLoader
  }
}
</script>

<style lang="scss" scoped>
  svg {
    max-width: 1440px;
    width: 100%;
    height: 656px;
    border-radius: 8px;

    @media (min-width: 992px) {
      height: 788px;
    }
  }
</style>
